import { render, staticRenderFns } from "./PolyIntegerReferenceUpdate.vue?vue&type=template&id=cb6070f0&"
import script from "./PolyIntegerReferenceUpdate.vue?vue&type=script&lang=js&"
export * from "./PolyIntegerReferenceUpdate.vue?vue&type=script&lang=js&"
import style0 from "./PolyIntegerReferenceUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports